<div class="border-bottom emergency-item">
  @if (emergencySummary(); as summary) {
    <div class="overview-grid" [style.grid-template-columns]="columnService.gridTemplateColumns()">

      <!-- arrivalInfo -->
      @if (visibleFields().has('arrivalInfo')) {
        <div class="grid-cell">
          <a [href]="navigationUrl()" class="arrival-link">
            <span class="text-info fw-medium mb-0 text-truncate">
              <span class="col-fixed-date">
                <app-highlight [result]="(originInfo().time | date:'dd MMM HH:mm') || 'No date'"></app-highlight>
              </span>
              <span> - </span>
              <app-highlight [result]="originInfo().name"></app-highlight>
            </span>
            <!-- TODO: Verify implementation with business rules -->
            @if (summary.incomingMovementHarbourMasterInfo?.remarks?.text) {
              <i class="fa-light fa-fw text-muted fa-comment"></i>
            } @else if (summary.incomingMovementHarbourMasterInfo?.pilotOnBoard) {
              <i class="fa-light fa-fw text-muted fa-arrow-right-arrow-left"></i>
            }
            @if (EmergencyOverviewUtils.isTidalShip(summary)) {
              <app-tooltip placement="top" class="ms-2">
                <span class="fa fa-fw fa-water-arrow-down text-info"></span>
                <span class="tooltipContent">This ship is tide restricted</span>
              </app-tooltip>
            }
            @if (EmergencyOverviewUtils.isShoreBasedPilotage(summary)) {
              <app-tooltip placement="top" class="ms-2">
                <span class="fa fa-fw"
                      [class.fa-check]="EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) === 'ACCEPTED'"
                      [class.text-portbase-green]="EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) === 'ACCEPTED'"
                      [class.fa-xmark]="EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) === 'NOT_ACCEPTED'"
                      [class.text-portbase-red]="EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) === 'NOT_ACCEPTED'"
                      [class.text-info]="EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) !== 'ACCEPTED'
                        && EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) !== 'NOT_ACCEPTED'">
                </span>
                <span class="tooltipContent">
                  @if (EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) === 'ACCEPTED') {
                    Shore based pilotage (LOA) accepted
                  } @else if (EmergencyOverviewUtils.getPilotFromDistanceStatus(summary) === 'NOT_ACCEPTED') {
                    Shore based pilotage (LOA) not accepted
                  } @else {
                    Shore based pilotage (LOA)
                  }
                </span>
              </app-tooltip>
            }
          </a>
        </div>
      }

      <!-- serviceStatusHarbour: left status set (harbour master + loodswezen) -->
      @if (visibleFields().has('serviceStatusHarbour')) {
        <div class="grid-cell status-cell">
          <app-status-indicator
            [messageStatuses]="harbourMasterStatuses()"
            [statusIndicatorButtonId]="'buttonHarbourMaster' + summary.crn"
            [statusIndicatorSpanId]="'spanHarbourMaster' + summary.crn">
          </app-status-indicator>
          @if (!summary.portUnCode || areNauticalServicesApplicable()) {
            <app-status-indicator
              [messageStatuses]="loodswezenStatuses()"
              [statusIndicatorButtonId]="'buttonLoodswezen' + summary.crn"
              [statusIndicatorSpanId]="'spanLoodswezen' + summary.crn">
            </app-status-indicator>
          }
        </div>
      }

      <!-- operations -->
      @if (visibleFields().has('operations')) {
        <div class="grid-cell">
          <!-- TODO: `operations` is a mock-only dummy field; wire to a real backend field once available -->
          <i class="fa-regular fa-fw fa-user-pilot text-muted"></i>
          <span>{{ summary.operations ? 'Yes' : 'No' }}</span>
        </div>
      }

      <!-- vessel -->
      @if (visibleFields().has('vessel')) {
        <div class="grid-cell">
          <span class="col-fixed-callsign">{{summary.vessel.radioCallSign}}</span>
          <span> - </span>
          <span class="text-truncate">{{summary.vessel.name}}</span>
        </div>
      }

      <!-- vesselLength -->
      @if (visibleFields().has('vesselLength')) {
        <div class="grid-cell">
          @if (summary.vessel.length) {
            <span>{{summary.vessel.length | round}} m</span>
          }
        </div>
      }

      <!-- vesselDraught -->
      @if (visibleFields().has('vesselDraught')) {
        <div class="grid-cell">
          @if (vesselDraught() != null) {
            <i class="fa-regular fa-fw fa-ruler-vertical text-muted"></i>
            <span>{{vesselDraught() | round}} m</span>
          }
        </div>
      }

      <!-- berthVisit -->
      @if (visibleFields().has('berthVisit')) {
        <div class="grid-cell">
          <span class="col-fixed-date">
            {{(targetInfo().time | date:'dd MMM HH:mm') || 'No date' }}
          </span>
          <span>&nbsp;-&nbsp;</span>
          <span class="text-truncate">
            {{targetInfo().name}}
          </span>
          @if (targetInfo().extra) {
            <span class="text-muted d-none d-lg-inline ms-1">{{targetInfo().extra}}</span>
          }
        </div>
      }

      <!-- lastUpdated -->
      @if (visibleFields().has('lastUpdated')) {
        <div class="grid-cell text-muted">
          <i class="fa-light fa-fw fa-pen-to-square"></i>
          <span>{{ sinceLastUpdate(summary.updated?.valueOf()) }}</span>
        </div>
      }

      <!-- nauticalServices -->
      <!-- Only present services render an icon; they pack together as a tight,
           left-aligned cluster within the fixed-width column. -->
      @if (visibleFields().has('nauticalServices')) {
        <div class="grid-cell nautical-services">
          <!-- TODO: `loodswezenAanwezig` is a mock-only dummy field; wire to a real backend field once available -->
          @if (summary.loodswezenAanwezig) {
            <i class="fa-light fa-fw fa-compass text-muted"></i>
          }
          @if (isBerth(summary.movementTargetPlace) && (summary.movementTargetPlace.numberOfTugboatsAtArrival || summary.movementTargetPlace.numberOfTugboatsAtDeparture)) {
            <span class="nautical-slot-tug">
              <i class="fa-light fa-fw fa-ship text-muted"></i>
              <span class="ms-1 text-muted">{{ summary.movementTargetPlace.numberOfTugboatsAtArrival ?
                getNumberOfTugboats(summary.movementTargetPlace.numberOfTugboatsAtArrival) :
                getNumberOfTugboats(summary.movementTargetPlace.numberOfTugboatsAtDeparture) }}</span>
            </span>
          }
          @if (EmergencyOverviewUtils.getBoatmenService(summary)?.required) {
            <i class="fa-light fa-fw fa-link text-muted"></i>
          }
          <!-- TODO: `helicopterbeloodsing` is a mock-only dummy field; wire to a real backend field once available -->
          @if (summary.helicopterbeloodsing) {
            <i class="fa-light fa-fw fa-helicopter text-muted"></i>
          }
          <!-- TODO: `loaApproved` is a mock-only dummy field; wire to a real backend field once available -->
          @if (summary.loaApproved) {
            <i class="fa-light fa-fw fa-headset text-muted"></i>
          }
          @if (movementOnHold()) {
            <span title="This movement has been put on hold by the port authorities and may proceed as conditions allow." class="ms-1 far fa-fw fa-hand-paper text-danger"></span>
          }
        </div>
      }

      <!-- serviceStatusOther -->
      @if (visibleFields().has('serviceStatusOther')) {
        <div class="grid-cell">
          <app-emergency-overview-service-status
            [summary]="summary"
            [declarationTypes]="declarationTypesOther"
            [statusIndicatorButtonId]="'buttonEmergencyProcedure' + summary.crn"
            [statusIndicatorSpanId]="'spanEmergencyProcedure' + summary.crn">
          </app-emergency-overview-service-status>
        </div>
      }

      <!-- actions -->
      <!-- Every action is a uniform icon button in a fixed slot (rendered even
           when the action is unavailable) so the buttons line up vertically
           across rows, matching the design. -->
      @if (visibleFields().has('actions')) {
        <div class="grid-cell action-btn">
          <!-- TODO: `pinned` is stored locally only (togglePin); wire to a real backend field/command once available -->
          <a (click)="togglePin()" class="btn action-icon rounded-circle text-primary" type="button">
            @if (summary.pinned) {
              <i class="fa-solid fa-fw text-primary fa-thumb-tack"></i>
            } @else {
              <i class="fa-light fa-fw text-primary fa-thumbtack-angle"></i>
            }
          </a>
          <span class="action-icon text-primary">
            @if (summary.unreadHarbourRemarks) {
              <i class="fa-light fa-fw fa-envelope-open"></i>
            } @else {
              <i class="fa-light fa-fw fa-envelope"></i>
            }
          </span>
          @if (appContext.isEmergencyProcedureEditor() || appContext.isPilotEmergencyProcedureViewer()) {
            <a (click)="openEditor()" class="btn action-icon rounded-circle text-primary" type="button">
              <i class="fa-light fa-fw fa-pencil"></i>
            </a>
          } @else {
            <span class="action-icon"></span>
          }
          <a [href]="navigationUrl()" class="btn action-icon rounded-circle text-primary" type="button">
            <i class="fa-light fa-fw fa-angle-right"></i>
          </a>
          <button class="btn action-icon rounded-circle text-primary" type="button"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa-light fa-fw fa-ellipsis-vertical"></i>
          </button>
          <div class="dropdown-menu position-fixed">
            @if (appContext.isAdmin()) {
              <button class="btn dropdown-item" (click)="tryRefreshEmergencyProcedureSummary()">
                <i class="fa-light fa-arrows-rotate"></i>
                Refresh emergency procedure summary
              </button>
            }
            <a [href]="'https://www.marinetraffic.com/en/ais/details/ships/imo:'+summary.imoCode"
               class="btn dropdown-item">
              <i class="fa-light fa-arrow-up-right-from-square"></i>
              View in MarineTraffic
            </a>
            @if (isOrganisationCurrentVisitDeclarant() && !summary.cancelled && expected()) {
              <hr class="dropdown-divider">
              <button class="btn dropdown-item" (click)="cancelVisit()">
                <i class="fa-light fa-ban"></i>
                Cancel visit
              </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
